/**
 * GSAP Entrypoint
 * Bundles GSAP with required plugins for Shopify theme
 */
import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

// Register plugins globally
gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, SplitText);

// Export for use in theme
export { gsap, DrawSVGPlugin, ScrollTrigger, SplitText };

// Also expose on window for inline scripts
if (typeof window !== 'undefined') {
  (window as any).gsap = gsap;
  (window as any).ScrollTrigger = ScrollTrigger;
  (window as any).SplitText = SplitText;
  (window as any).DrawSVGPlugin = DrawSVGPlugin;
}
